export default __webpack_public_path__ + "static/media/3.2ebd0793.jpg";